/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem, RelatedContentModal, SelectField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const CATEGORIES = [
  { value: 'Fan', label: 'Fan' },
  { value: 'Athlete', label: 'Athlete' },
  { value: 'Works in Sport', label: 'Works in sport' },
];
const CATEGORIES_MAP = CATEGORIES.reduce((acc, tag) => ({ ...acc, [tag.value]: tag }), {});

const CATEGORIES_FIELD = {
  name: 'userCategories',
  options: CATEGORIES,
  selectOptions: { placeholder: 'Choose a user category:' },
  rules: [{ required: true, message: 'User category is required' }],
};

const RelatedCategoryModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add user category"
    subtitle="Find a user category related to this article"
    okText="ADD CATEGORY"
    onSubmit={({ userCategories }) => onSubmit(userCategories)}
  >
    <SelectField {...CATEGORIES_FIELD} style={NO_MARGIN_BOTTOM} />
  </RelatedContentModal>
);

const Item = (categoryKey) => {
  const categoryLabel = CATEGORIES_MAP[categoryKey]?.label;

  return <InfoItem>{categoryLabel || categoryKey}</InfoItem>;
};

RelatedCategoryModal.Item = Item;

export default RelatedCategoryModal;
